import { Reducer } from 'redux';
import { PagadorArmazenagemState, PagadorArmazenagemTypes } from './types';

const INITIAL_STATE: PagadorArmazenagemState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<PagadorArmazenagemState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PagadorArmazenagemTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PagadorArmazenagemTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case PagadorArmazenagemTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case PagadorArmazenagemTypes.CLEAN_PAG_ARMAZENAGEM:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
